import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';
import questionTypes from 'FlowBuilder/components/ActionForms/Survey/question-types'
import { useAct } from 'DashboardBuilder/store'
import QuestionForm from 'FlowBuilder/components/ActionForms/Survey/QuestionForm';
import ColorCodeOption from './components/ColorCodeOption'

export const AnswerableQuestionEditor = ({ field, onChange }: FieldEditorProps) => {
  const act = useAct()
  const { questionId } = field
  const question = useSel(s => s.questions.entities[questionId] || {})
  const dashboardQuestionOptionKeys = _.keys(questionTypes).filter(qt => questionTypes[qt].dashboardDisabled !== true)
  const questionConfig = questionTypes[question?.questionType]
  const mergeTags = {}
  
  function chooseQuestionType(questionType) {
    act.dashboardFields.chooseQuestionType(field.id, questionType)
    const { colorCodeBoolean, ...restConfig } = field?.config || {};
    onChange({ config: restConfig });
  }

  return <>
    <div className="field-editor-row">
      <label>Question Type</label>
      <div className="field-editor-input">
        <select value={question.questionType || ''} onChange={e => chooseQuestionType(e.target.value)}>
          <option value={''}>Choose a question type</option>
          { _.map(dashboardQuestionOptionKeys, (qt) => <option value={qt}>{questionTypes[qt].name}</option> ) }
        </select>
      </div>
    </div>
    { (questionId && questionConfig) && <div className="field-editor-row">
      <QuestionForm question={question} questionConfig={{...questionConfig, showRequired: false}} mergeTags={mergeTags} nameDisabled={true} />
    </div> }
    { (question.questionType === 'checkbox' || question.questionType === 'opt_in_radio') &&
      <ColorCodeOption field={field} onChange={onChange} />
    }
  </>
}
